import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAtom } from 'jotai/index';
import styles from './css/index.module.scss';
import useTranslations from '../../../../hooks/useTranslations';
import { DICTIONARY } from '../../../../translations/dictionary';
import Checkbox from '../../../../ui-kit/Checkbox';
import IconButton from '../../../../ui-kit/IconButton';
import Api from '../../../../api';
import sendRequest from '../../../../helpers/sendRequest';
import { openInfoModalAtom } from '../../../../atoms/modalAtoms';

import ArchiveIcon from '../../../../assets/icons/download.svg';
import DockIcon from '../../../../assets/icons/document.svg';
import EmailIcon from '../../../../assets/icons/email.svg';
import CrossIcon from '../../../../assets/icons/crossDark.svg';
import { isAdminAtom } from '../../../../atoms/accountAtoms';
import useProjects from '../../../../hooks/useProjects';
import useConfigurations from '../../../../hooks/useConfigurations';

function ProjectsSelectingButtons({
  allItems,
  selectedItems,
  setSelectedItems,
  isForProjects,
  isForHistory,
}) {
  const { t } = useTranslations();

  const {
    onDeleteProjectsClick,
    downloadProjectsArchive,
    downloadProjectsFile,
    emailProjectsArchive,
  } = useProjects({ setSelectedItems });

  const {
    downloadConfigurationsArchive,
    downloadConfigurationsFile,
    emailConfigurationsArchive,
    onDeleteConfigurationsClick,
  } = useConfigurations({ setSelectedItems });

  const [isAdmin] = useAtom(isAdminAtom);

  const onArchiveClick = async () => {
    if (isForProjects) await downloadProjectsArchive(selectedItems);
    else await downloadConfigurationsArchive(selectedItems);
  };

  const onFileClick = async () => {
    if (isForProjects) await downloadProjectsFile(selectedItems);
    else await downloadConfigurationsFile(selectedItems);
  };

  const onEmailClick = async () => {
    if (isForProjects) await emailProjectsArchive(selectedItems);
    else await emailConfigurationsArchive(selectedItems);
  };

  const onDeleteClick = async () => {
    if (isForProjects) onDeleteProjectsClick(selectedItems);
    else if (isForHistory) onDeleteConfigurationsClick(selectedItems);
  };

  const onSelectAllClick = () => {
    if (selectedItems.length) setSelectedItems([]);
    else setSelectedItems(allItems.map((i) => i.id));
  };

  return (
    <div className={styles.buttonWrapper}>
      <div className={styles.checkbox}>
        <Checkbox
          onClick={onSelectAllClick}
          text={`${t(DICTIONARY.selected)} ${selectedItems.length}`}
          value={selectedItems.length}
        />
      </div>
      <IconButton
        onClick={onArchiveClick}
        isDisabled={!selectedItems.length}
        text={t(DICTIONARY.saveToArchive)}
        icon={ArchiveIcon}
        hideTextOnMobile
      />
      <IconButton
        onClick={onFileClick}
        isDisabled={!selectedItems.length}
        text={t(DICTIONARY.saveToDocx)}
        icon={DockIcon}
        hideTextOnMobile
      />
      <IconButton
        onClick={onEmailClick}
        isDisabled={!selectedItems.length}
        text={t(DICTIONARY.sendByEmail)}
        icon={EmailIcon}
        hideTextOnMobile
      />
      {(isForProjects || isForHistory) && (
        <IconButton
          onClick={onDeleteClick}
          isDisabled={!selectedItems.length}
          text={t(DICTIONARY.delete)}
          icon={CrossIcon}
          hideTextOnMobile
        />
      )}
    </div>
  );
}

export default ProjectsSelectingButtons;
